// extracted by mini-css-extract-plugin
export default {"container":"wp-z","ratingLayout":"xp-z","ratingLabel":"yp-z","nonInteractiveRatingLabel":"zp-z"};